exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-sort-options{align-items:flex-end;display:flex;flex-direction:row;margin-bottom:14px;position:relative}.search-sort-options__label{font-family:\"Bebas Neue\",\"bebas-fallback\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-size:1.286em;padding:1px;white-space:nowrap}@media (max-width: 639px){.search-sort-options{margin-bottom:-1px}}\n", ""]);

// exports
exports.locals = {
	"search-sort-options": "search-sort-options",
	"search-sort-options__label": "search-sort-options__label"
};